import {
  SET_PLANNED_TWIN_ID_UPDATE_PLAN,
  RESET_PLANNED_TWIN_ID_UPDATE,
  SET_IS_APPLYING_PLANNED_TWIN_ID_UPDATE,
  SET_IS_PLANNING_PLANNED_TWIN_ID_UPDATE,
  SET_PLANNED_TWIN_ID_UPDATE_ERROR,
  SET_PLANNED_TWIN_ID_UPDATE_SHOW_CHANGES_ONLY,
  SET_PLANNED_TWIN_ID_UPDATE_MODE,
  SET_PLANNED_TWIN_ID_UPDATE_FILE,
  SET_EXISTING_PLANNED_TWIN_IDS,
} from '../actions/actionTypes';
import { PlannedTwinIDUpdateAction, PlannedTwinIDUpdateStateType } from '../context';

export default (
  state: PlannedTwinIDUpdateStateType,
  action: PlannedTwinIDUpdateAction,
): PlannedTwinIDUpdateStateType => {
  switch (action.type) {
    case SET_PLANNED_TWIN_ID_UPDATE_FILE:
      return {
        ...state,
        fileName: action.payload.name,
        fileContents: action.payload.contents,
      };
    case SET_IS_PLANNING_PLANNED_TWIN_ID_UPDATE:
      return {
        ...state,
        isPlanningPlannedTwinIDs: action.payload,
      };
    case SET_PLANNED_TWIN_ID_UPDATE_PLAN: {
      return {
        ...state,
        importTime: new Date(),
        plannedUpdatedPlannedTwinID: action.payload,
      };
    }
    case SET_EXISTING_PLANNED_TWIN_IDS: {
      return {
        ...state,
        existingPlannedTwinIDs: action.payload,
      };
    }
    case SET_IS_APPLYING_PLANNED_TWIN_ID_UPDATE:
      return {
        ...state,
        isApplyingPlannedTwinIDs: action.payload,
      };
    case SET_PLANNED_TWIN_ID_UPDATE_ERROR:
      return {
        ...state,
        error: action.payload,
      };
    case RESET_PLANNED_TWIN_ID_UPDATE:
      return {
        ...state,
        isPlanningPlannedTwinIDs: false,
        isApplyingPlannedTwinIDs: false,
        plannedUpdatedPlannedTwinID: null,
        fileName: null,
        fileContents: null,
      };
    case SET_PLANNED_TWIN_ID_UPDATE_MODE:
      return {
        ...state,
        plannedTwinIDUpdateMode: action.payload,
      };
    case SET_PLANNED_TWIN_ID_UPDATE_SHOW_CHANGES_ONLY:
      return {
        ...state,
        showChangesOnly: action.payload,
      };
    default:
      return state;
  }
};
